import SocialAccountProvider from './socialAccountProvider'

export const assetsForFile = (file, providers) => {
  switch(file.type) {
    case 'graphic':
      return file.attributes.formats.map(format => {

        return {
          key: ["graphic", file.id, format.id].join('-'),
          format: format.id,
          id: file.id,
          type: 'graphic',
          name: format.title,
          story: format.story,
          video: format.video,
          dimensions: format.width && format.height ? `${format.width} x ${format.height}` : null,
          previewUrl: file.attributes.preview_urls[format.id],
          enabledActions: providersForGraphicFormat(format, providers).map(provider => actionForProvider(provider, format.story))
        }
      })
    case 'upload':
      return [{
        key: ["upload", file.id].join('-'),
        id: file.id,
        type: 'upload',
        video: file.attributes.video,
        name: file.attributes.filename,
        dimensions: file.attributes.width && file.attributes.height ? `${file.attributes.width} x ${file.attributes.height}` : null,
        previewUrl: file.attributes.thumb_url,
        enabledActions: providers.map(provider => actionForProvider(provider, false))
      }]
  }
}

const providersForGraphicFormat = (format, providers) => {
  const storyProviders = providers.filter(provider => SocialAccountProvider.find(provider).supportsStory)

  if (format.story) return storyProviders
  if (format.social === 'all') return providers

  return format.social
    .split(',')
    .map(p => p.trim())
    .filter(provider => providers.includes(provider))
}

export const actionForProvider = (providerName, story) => {
  const provider = SocialAccountProvider.find(providerName)
  const verb = story ? 'Story' : provider.postName

  return {
    provider: provider.name,
    story: story,
    key: [provider.name, verb.toLowerCase()].join('-'),
    name: [provider.title, verb].join(' ')
  }
}

export const actionsForProvider = (providerName) => {
  const provider = SocialAccountProvider.find(providerName)
  const actions = [actionForProvider(providerName, false)]

  if (provider.supportsStory) {
    actions.push(actionForProvider(providerName, true))
  }

  return actions
}